<template>
    <vx-modal :visible="props.visible"
        @update:visible="emit('update:visible', $event)"
        :padding="false"
        size="md">
        <template v-slot:header>
            <div class="px-6 pt-6">
                Schedule Message
            </div>
        </template>
        <template v-slot:subheader>
            <div class="px-6">
                Sends message at a later date.
            </div>
        </template>

        <form id="message-builder-schedule"
            @submit.prevent="submit"
            class="px-6 py-12 flex flex-col items-center gap-2">
            <div class="text-center text-sm text-slate-700">
                {{ dateFormatted }}
            </div>
            <vx-date-picker :key="minDateKey"
                v-model="date"
                mode="datetime"
                :timezone="getClientTz()"
                :minDate="minDate"
                :maxDate="maxDate"
                isRequired></vx-date-picker>
        </form>

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button @click="emit('update:visible', false)"
                    size="lg"
                    color="muted">
                    Cancel
                    <font-awesome-icon widthAuto :icon="faCircleX"></font-awesome-icon>
                </vx-button>
                <vx-button form="message-builder-schedule"
                    type="submit"
                    size="lg"
                    color="primary"
                    :loading="props.uploading"
                    :disabled="props.uploading"
                    data-test="schedule-button"
                    class="lg:grow">
                    Schedule Message
                    <font-awesome-icon widthAuto :icon="faPaperPlane"></font-awesome-icon>
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleX, faPaperPlane } from '@fortawesome/pro-solid-svg-icons';
import { VxModal, VxButton, VxDatePicker } from '@voxie/frontend-components';
import { computed, ref, watch } from 'vue';
import { formatTz, getClientTz } from '../../../../utils/date';
import dayjs, { toUTCDateTimeFormat } from '~/utils/dayjs';
import { useInterval } from '@vueuse/core';

const props = defineProps({
    visible: Boolean,
    uploading: Boolean,
    sendAt: {
        type: String,
    }
});

const minDate = computed(() => dayjs().tz(getClientTz()).add(15, 'minutes').toDate());
const maxDate = computed(() => dayjs().tz(getClientTz()).add(89, 'days').toDate());
const date = ref(props.sendAt ?
    dayjs.utc(props.sendAt).tz(getClientTz()).toDate() :
    dayjs().tz(getClientTz()).add(1, 'hour').toDate()
);

const dateFormatted = computed(() => {
    const timezone = dayjs(date.value).tz(getClientTz()).format('z');

    return dayjs(date.value).tz(getClientTz()).format("MMM DD, YYYY [at] h:mm a") +
        ' ' +
        formatTz(timezone)
});

const minDateKey = useInterval(60000);

const emit = defineEmits(['update:visible', 'schedule']);

watch([() => props.visible, () => props.sendAt], () => {
    date.value = props.sendAt ?
        dayjs.utc(props.sendAt).tz(getClientTz()).toDate() :
        dayjs().tz(getClientTz()).add(1, 'hour').toDate();
})

const submit = async () => {
    if (props.uploading) {
        return;
    }

    emit('schedule', toUTCDateTimeFormat(dayjs(date.value).tz(getClientTz())));
    emit('update:visible', false)
}
</script>
